<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Banners</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary lighten-4"
            @click="$router.push('banners/adicionar')"
            class="hidden-xs-only"
            >Adicionar</v-btn
          >
          <v-btn
            icon
            @click="$router.push('banners/adicionar')"
            class="hidden-sm-and-up"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-app-bar>
        <v-data-table
          :headers="headers"
          :items="banners"
          no-data-text="Nenhum banner cadastrado"
          :items-per-page="30"
          :footer-props="{
            itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }],
            itemsPerPageText: 'Registros Exibidos',
          }"
        >
          <template v-slot:item.imagem="{ item }">
            <img
              :src="item.imagem"
              height="48px"
              style="border-radius: 4px; border: 1px solid #eee"
              class="mt-2 mb-1"
            />
          </template>
          <template v-slot:item.data_inicio="{ item }">{{
            item.data_inicio | dataBR
          }}</template>
          <template v-slot:item.data_fim="{ item }">{{
            item.data_fim | dataBR
          }}</template>
          <template v-slot:item.status="{ item }">
            <v-chip
              label
              color="success"
              small
              v-if="item.status == 1"
              style="min-width: 120px;"
              class="justify-center"
              >Publicado</v-chip
            >
            <v-chip
              label
              color="error"
              small
              v-if="item.status == 2"
              style="min-width: 120px;"
              class="justify-center"
              >Em análise</v-chip
            >
          </template>
          <template v-slot:item.acoes="{ item }">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  @click="$router.push('banners/' + item.id + '/editar')"
                >
                  <v-list-item-title>
                    <v-icon class="pr-4">edit</v-icon>Editar
                  </v-list-item-title>
                </v-list-item>

                <v-list-item @click="abrirDialogoExcluir(item)">
                  <v-list-item-title>
                    <v-icon class="pr-4">delete</v-icon>Excluir
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <as-dialogo
      ref="dialogoExcluirBanner"
      title="Excluir"
      max-width="440px"
      hideCloseButton
    >
      <v-label>Tem certeza que deseja excluir o banner selecionado?</v-label>
      <div class="pt-4" style="display: flex; justify-content: flex-end;">
        <v-btn
          depressed
          class="mr-4"
          @click="$refs.dialogoExcluirBanner.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="error"
          @click="excluirBanner"
          :disabled="loadingExcluir"
          :loading="loadingExcluir"
          >Excluir</v-btn
        >
      </div>
    </as-dialogo>
  </div>
</template>

<script>
import ServiceBanners from "../services/banners.js";

export default {
  name: "Banners",
  data() {
    return {
      loading: false,
      loadingExcluir: false,
      user: {},
      headers: [
        { text: "Imagem", value: "imagem", width: "10%", sortable: false },
        { text: "Nome", value: "nome", width: "30%", sortable: false },
        { text: "Início", value: "data_inicio", width: "20%", sortable: false },
        { text: "Fim", value: "data_fim", width: "20%", sortable: false },
        {
          text: "Status",
          value: "status",
          sortable: false,
          width: "10%",
        },
        {
          text: "",
          value: "acoes",
          align: "center",
          sortable: false,
          width: "10%",
        },
      ],
      banners: [],
      bannerSelecionado: null,
    };
  },
  mounted() {
    this.rodada = JSON.parse(localStorage.getItem("rodada"));
    this.user = { ...this.$auth.user };
    this.listarBanners();
  },
  methods: {
    async listarBanners() {
      try {
        let response = await ServiceBanners.index();
        this.banners = response.data.banners;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar os banners");
      } finally {
        //
      }
    },
    abrirDialogoExcluir(banner) {
      this.bannerSelecionado = this.clone(banner);
      this.$refs.dialogoExcluirBanner.abrir();
    },
    async excluirBanner() {
      try {
        this.loadingExcluir = true;
        let response = await ServiceBanners.excluir(this.bannerSelecionado.id);
        let indice = this.banners.findIndex(
          (banner) => banner.id === this.bannerSelecionado.id
        );
        this.banners.splice(indice, 1);
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao excluir banner");
      } finally {
        this.loadingExcluir = false;
        this.$refs.dialogoExcluirBanner.fechar();
      }
    },
  },
};
</script>

<style></style>
